// src/data/cities/index.js
//
// CITIES_INDEX — lightweight summary of every city with a dedicated
// city page (currently 271 cities across 50 states).
//
// Each entry holds just the fields needed by listing surfaces:
//   - CityPage's sibling-cities grid (same-state cities)
//   - CityPage's cross-state nearby grid (adjacency-driven)
//   - StatePage's "cities we cover" grid
//   - StatePage's cityZipBySlug map for top-cities deep-links
//
// The full record for a focused city (neighborhoodDetail, localQuirks,
// costRange, contaminantHighlights, costTier, sourceType, utility,
// metro, notes, elevation) lives in ./<stateSlug>.js and is loaded
// only when CityPage renders that state's per-state module via
// loadCitiesByState(stateSlug).
//
// Generated by scripts/split-cities.mjs (session 36).

export const CITIES_INDEX = [
  {
    "citySlug": "wilmington",
    "cityName": "Wilmington",
    "stateSlug": "delaware",
    "hardness": 145,
    "populationK": 71,
    "firstZip": "19801",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        94,
        228
      ]
    }
  },
  {
    "citySlug": "dover",
    "cityName": "Dover",
    "stateSlug": "delaware",
    "hardness": 75,
    "populationK": 39,
    "firstZip": "19901",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        23,
        127
      ]
    }
  },
  {
    "citySlug": "newark",
    "cityName": "Newark",
    "stateSlug": "delaware",
    "hardness": 68,
    "populationK": 31,
    "firstZip": "19711",
    "hardnessSourcing": {
      "shape": "point",
      "value": 68
    }
  },
  {
    "citySlug": "middletown",
    "cityName": "Middletown",
    "stateSlug": "delaware",
    "hardness": 160,
    "populationK": 23,
    "firstZip": "19709",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "smyrna",
    "cityName": "Smyrna",
    "stateSlug": "delaware",
    "hardness": 175,
    "populationK": 13,
    "firstZip": "19977",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "providence",
    "cityName": "Providence",
    "stateSlug": "rhode-island",
    "hardness": 50,
    "populationK": 191,
    "firstZip": "02903",
    "hardnessSourcing": {
      "shape": "qualitative",
      "operatorWord": "soft"
    }
  },
  {
    "citySlug": "warwick",
    "cityName": "Warwick",
    "stateSlug": "rhode-island",
    "hardness": 55,
    "populationK": 83,
    "firstZip": "02886",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "cranston",
    "cityName": "Cranston",
    "stateSlug": "rhode-island",
    "hardness": 50,
    "populationK": 82,
    "firstZip": "02905",
    "hardnessSourcing": {
      "shape": "qualitative",
      "operatorWord": "soft"
    }
  },
  {
    "citySlug": "pawtucket",
    "cityName": "Pawtucket",
    "stateSlug": "rhode-island",
    "hardness": 50,
    "populationK": 75,
    "firstZip": "02860",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "east-providence",
    "cityName": "East Providence",
    "stateSlug": "rhode-island",
    "hardness": 50,
    "populationK": 47,
    "firstZip": "02914",
    "hardnessSourcing": {
      "shape": "qualitative",
      "operatorWord": "soft"
    }
  },
  {
    "citySlug": "wichita",
    "cityName": "Wichita",
    "stateSlug": "kansas",
    "hardness": 150,
    "populationK": 398,
    "firstZip": "67202",
    "hardnessSourcing": {
      "shape": "point",
      "value": 150
    }
  },
  {
    "citySlug": "overland-park",
    "cityName": "Overland Park",
    "stateSlug": "kansas",
    "hardness": 144,
    "populationK": 199,
    "firstZip": "66204",
    "hardnessSourcing": {
      "shape": "point",
      "value": 144
    }
  },
  {
    "citySlug": "kansas-city",
    "cityName": "Kansas City",
    "stateSlug": "kansas",
    "hardness": 300,
    "populationK": 157,
    "firstZip": "66101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 300
    }
  },
  {
    "citySlug": "olathe",
    "cityName": "Olathe",
    "stateSlug": "kansas",
    "hardness": 180,
    "populationK": 146,
    "firstZip": "66061",
    "hardnessSourcing": {
      "shape": "point",
      "value": 180
    }
  },
  {
    "citySlug": "topeka",
    "cityName": "Topeka",
    "stateSlug": "kansas",
    "hardness": 154,
    "populationK": 125,
    "firstZip": "66603",
    "hardnessSourcing": {
      "shape": "point",
      "value": 154
    }
  },
  {
    "citySlug": "jackson",
    "cityName": "Jackson",
    "stateSlug": "mississippi",
    "hardness": 140,
    "populationK": 143,
    "firstZip": "39201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "gulfport",
    "cityName": "Gulfport",
    "stateSlug": "mississippi",
    "hardness": 110,
    "populationK": 72,
    "firstZip": "39501",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "southaven",
    "cityName": "Southaven",
    "stateSlug": "mississippi",
    "hardness": 95,
    "populationK": 56,
    "firstZip": "38671",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "hattiesburg",
    "cityName": "Hattiesburg",
    "stateSlug": "mississippi",
    "hardness": 130,
    "populationK": 49,
    "firstZip": "39401",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "biloxi",
    "cityName": "Biloxi",
    "stateSlug": "mississippi",
    "hardness": 110,
    "populationK": 48,
    "firstZip": "39530",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "omaha",
    "cityName": "Omaha",
    "stateSlug": "nebraska",
    "hardness": 170,
    "populationK": 491,
    "firstZip": "68102",
    "hardnessSourcing": {
      "shape": "point",
      "value": 170
    }
  },
  {
    "citySlug": "lincoln",
    "cityName": "Lincoln",
    "stateSlug": "nebraska",
    "hardness": 192,
    "populationK": 296,
    "firstZip": "68502",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        180,
        236
      ]
    }
  },
  {
    "citySlug": "bellevue",
    "cityName": "Bellevue",
    "stateSlug": "nebraska",
    "hardness": 170,
    "populationK": 64,
    "firstZip": "68005",
    "hardnessSourcing": {
      "shape": "point",
      "value": 170
    }
  },
  {
    "citySlug": "grand-island",
    "cityName": "Grand Island",
    "stateSlug": "nebraska",
    "hardness": 342,
    "populationK": 53,
    "firstZip": "68801",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        308,
        377
      ]
    }
  },
  {
    "citySlug": "kearney",
    "cityName": "Kearney",
    "stateSlug": "nebraska",
    "hardness": 270,
    "populationK": 34,
    "firstZip": "68845",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "albuquerque",
    "cityName": "Albuquerque",
    "stateSlug": "new-mexico",
    "hardness": 151,
    "populationK": 562,
    "firstZip": "87102",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        43,
        230
      ]
    }
  },
  {
    "citySlug": "las-cruces",
    "cityName": "Las Cruces",
    "stateSlug": "new-mexico",
    "hardness": 275,
    "populationK": 113,
    "firstZip": "88001",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "rio-rancho",
    "cityName": "Rio Rancho",
    "stateSlug": "new-mexico",
    "hardness": 245,
    "populationK": 109,
    "firstZip": "87124",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "santa-fe",
    "cityName": "Santa Fe",
    "stateSlug": "new-mexico",
    "hardness": 175,
    "populationK": 89,
    "firstZip": "87501",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "roswell",
    "cityName": "Roswell",
    "stateSlug": "new-mexico",
    "hardness": 360,
    "populationK": 47,
    "firstZip": "88201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "fargo",
    "cityName": "Fargo",
    "stateSlug": "north-dakota",
    "hardness": 120,
    "populationK": 130,
    "firstZip": "58102",
    "hardnessSourcing": {
      "shape": "point",
      "value": 120
    }
  },
  {
    "citySlug": "bismarck",
    "cityName": "Bismarck",
    "stateSlug": "north-dakota",
    "hardness": 132,
    "populationK": 73,
    "firstZip": "58501",
    "hardnessSourcing": {
      "shape": "point",
      "value": 132
    }
  },
  {
    "citySlug": "grand-forks",
    "cityName": "Grand Forks",
    "stateSlug": "north-dakota",
    "hardness": 115,
    "populationK": 59,
    "firstZip": "58201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "west-fargo",
    "cityName": "West Fargo",
    "stateSlug": "north-dakota",
    "hardness": 120,
    "populationK": 41,
    "firstZip": "58078",
    "hardnessSourcing": {
      "shape": "point",
      "value": 120
    }
  },
  {
    "citySlug": "minot",
    "cityName": "Minot",
    "stateSlug": "north-dakota",
    "hardness": 125,
    "populationK": 47,
    "firstZip": "58701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        100,
        150
      ]
    }
  },
  {
    "citySlug": "sioux-falls",
    "cityName": "Sioux Falls",
    "stateSlug": "south-dakota",
    "hardness": 209,
    "populationK": 197,
    "firstZip": "57104",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        168,
        250
      ]
    }
  },
  {
    "citySlug": "rapid-city",
    "cityName": "Rapid City",
    "stateSlug": "south-dakota",
    "hardness": 140,
    "populationK": 75,
    "firstZip": "57701",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "aberdeen",
    "cityName": "Aberdeen",
    "stateSlug": "south-dakota",
    "hardness": 240,
    "populationK": 28,
    "firstZip": "57401",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "brookings",
    "cityName": "Brookings",
    "stateSlug": "south-dakota",
    "hardness": 220,
    "populationK": 24,
    "firstZip": "57006",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "watertown",
    "cityName": "Watertown",
    "stateSlug": "south-dakota",
    "hardness": 230,
    "populationK": 22,
    "firstZip": "57201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "burlington",
    "cityName": "Burlington",
    "stateSlug": "vermont",
    "hardness": 64,
    "populationK": 44,
    "firstZip": "05401",
    "hardnessSourcing": {
      "shape": "point",
      "value": 64
    }
  },
  {
    "citySlug": "south-burlington",
    "cityName": "South Burlington",
    "stateSlug": "vermont",
    "hardness": 60,
    "populationK": 20,
    "firstZip": "05403",
    "hardnessSourcing": {
      "shape": "point",
      "value": 60
    }
  },
  {
    "citySlug": "colchester",
    "cityName": "Colchester",
    "stateSlug": "vermont",
    "hardness": 60,
    "populationK": 17,
    "firstZip": "05446",
    "hardnessSourcing": {
      "shape": "point",
      "value": 60
    }
  },
  {
    "citySlug": "essex",
    "cityName": "Essex",
    "stateSlug": "vermont",
    "hardness": 60,
    "populationK": 22,
    "firstZip": "05452",
    "hardnessSourcing": {
      "shape": "point",
      "value": 60
    }
  },
  {
    "citySlug": "rutland",
    "cityName": "Rutland",
    "stateSlug": "vermont",
    "hardness": 175,
    "populationK": 15,
    "firstZip": "05701",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "manchester",
    "cityName": "Manchester",
    "stateSlug": "new-hampshire",
    "hardness": 145,
    "populationK": 116,
    "firstZip": "03101",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "nashua",
    "cityName": "Nashua",
    "stateSlug": "new-hampshire",
    "hardness": 21,
    "populationK": 91,
    "firstZip": "03060",
    "hardnessSourcing": {
      "shape": "point",
      "value": 20.8
    }
  },
  {
    "citySlug": "concord",
    "cityName": "Concord",
    "stateSlug": "new-hampshire",
    "hardness": 9,
    "populationK": 44,
    "firstZip": "03301",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        9,
        10
      ]
    }
  },
  {
    "citySlug": "portsmouth",
    "cityName": "Portsmouth",
    "stateSlug": "new-hampshire",
    "hardness": 44,
    "populationK": 22,
    "firstZip": "03801",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        13,
        204
      ]
    }
  },
  {
    "citySlug": "dover",
    "cityName": "Dover",
    "stateSlug": "new-hampshire",
    "hardness": 64,
    "populationK": 33,
    "firstZip": "03820",
    "hardnessSourcing": {
      "shape": "qualitative",
      "operatorWord": "moderately hard to hard"
    }
  },
  {
    "citySlug": "portland",
    "cityName": "Portland",
    "stateSlug": "maine",
    "hardness": 7.2,
    "populationK": 68,
    "firstZip": "04101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 7.2
    }
  },
  {
    "citySlug": "lewiston",
    "cityName": "Lewiston",
    "stateSlug": "maine",
    "hardness": 17,
    "populationK": 38,
    "firstZip": "04240",
    "hardnessSourcing": {
      "shape": "point",
      "value": 17,
      "operatorWord": "soft"
    }
  },
  {
    "citySlug": "bangor",
    "cityName": "Bangor",
    "stateSlug": "maine",
    "hardness": 5,
    "populationK": 32,
    "firstZip": "04401",
    "hardnessSourcing": {
      "shape": "point",
      "value": 5.3
    }
  },
  {
    "citySlug": "south-portland",
    "cityName": "South Portland",
    "stateSlug": "maine",
    "hardness": 7.2,
    "populationK": 26,
    "firstZip": "04106",
    "hardnessSourcing": {
      "shape": "point",
      "value": 7.2
    }
  },
  {
    "citySlug": "auburn",
    "cityName": "Auburn",
    "stateSlug": "maine",
    "hardness": 17,
    "populationK": 25,
    "firstZip": "04210",
    "hardnessSourcing": {
      "shape": "point",
      "value": 17,
      "operatorWord": "soft"
    }
  },
  {
    "citySlug": "boise",
    "cityName": "Boise",
    "stateSlug": "idaho",
    "hardness": 310,
    "populationK": 240,
    "firstZip": "83702",
    "hardnessSourcing": {
      "shape": "unlocated"
    }
  },
  {
    "citySlug": "meridian",
    "cityName": "Meridian",
    "stateSlug": "idaho",
    "hardness": 119,
    "populationK": 134,
    "firstZip": "83642",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        87,
        150
      ]
    }
  },
  {
    "citySlug": "nampa",
    "cityName": "Nampa",
    "stateSlug": "idaho",
    "hardness": 61,
    "populationK": 110,
    "firstZip": "83651",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        0,
        121
      ]
    }
  },
  {
    "citySlug": "idaho-falls",
    "cityName": "Idaho Falls",
    "stateSlug": "idaho",
    "hardness": 240,
    "populationK": 67,
    "firstZip": "83401",
    "hardnessSourcing": {
      "shape": "point",
      "value": 240
    }
  },
  {
    "citySlug": "caldwell",
    "cityName": "Caldwell",
    "stateSlug": "idaho",
    "hardness": 285,
    "populationK": 64,
    "firstZip": "83605",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "billings",
    "cityName": "Billings",
    "stateSlug": "montana",
    "hardness": 143,
    "populationK": 117,
    "firstZip": "59101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        52,
        233
      ]
    }
  },
  {
    "citySlug": "missoula",
    "cityName": "Missoula",
    "stateSlug": "montana",
    "hardness": 175,
    "populationK": 76,
    "firstZip": "59801",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "great-falls",
    "cityName": "Great Falls",
    "stateSlug": "montana",
    "hardness": 155,
    "populationK": 60,
    "firstZip": "59401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        127,
        167
      ]
    }
  },
  {
    "citySlug": "bozeman",
    "cityName": "Bozeman",
    "stateSlug": "montana",
    "hardness": 87,
    "populationK": 56,
    "firstZip": "59715",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        62.4,
        185.6
      ]
    }
  },
  {
    "citySlug": "butte",
    "cityName": "Butte",
    "stateSlug": "montana",
    "hardness": 195,
    "populationK": 35,
    "firstZip": "59701",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "charleston",
    "cityName": "Charleston",
    "stateSlug": "west-virginia",
    "hardness": 36,
    "populationK": 47,
    "firstZip": "25301",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        17,
        55
      ]
    }
  },
  {
    "citySlug": "huntington",
    "cityName": "Huntington",
    "stateSlug": "west-virginia",
    "hardness": 154,
    "populationK": 45,
    "firstZip": "25701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        62,
        154
      ]
    }
  },
  {
    "citySlug": "morgantown",
    "cityName": "Morgantown",
    "stateSlug": "west-virginia",
    "hardness": 105,
    "populationK": 30,
    "firstZip": "26505",
    "hardnessSourcing": {
      "shape": "point",
      "value": 104.8
    }
  },
  {
    "citySlug": "wheeling",
    "cityName": "Wheeling",
    "stateSlug": "west-virginia",
    "hardness": 195,
    "populationK": 26,
    "firstZip": "26003",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "martinsburg",
    "cityName": "Martinsburg",
    "stateSlug": "west-virginia",
    "hardness": 185,
    "populationK": 18,
    "firstZip": "25401",
    "hardnessSourcing": {
      "shape": "unlocated"
    }
  },
  {
    "citySlug": "cheyenne",
    "cityName": "Cheyenne",
    "stateSlug": "wyoming",
    "hardness": 59,
    "populationK": 65,
    "firstZip": "82001",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        46,
        69
      ]
    }
  },
  {
    "citySlug": "casper",
    "cityName": "Casper",
    "stateSlug": "wyoming",
    "hardness": 230,
    "populationK": 59,
    "firstZip": "82601",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "laramie",
    "cityName": "Laramie",
    "stateSlug": "wyoming",
    "hardness": 200,
    "populationK": 32,
    "firstZip": "82070",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "gillette",
    "cityName": "Gillette",
    "stateSlug": "wyoming",
    "hardness": 400,
    "populationK": 33,
    "firstZip": "82716",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        315,
        496
      ]
    }
  },
  {
    "citySlug": "rock-springs",
    "cityName": "Rock Springs",
    "stateSlug": "wyoming",
    "hardness": 240,
    "populationK": 23,
    "firstZip": "82901",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "anchorage",
    "cityName": "Anchorage",
    "stateSlug": "alaska",
    "hardness": 108,
    "populationK": 285,
    "firstZip": "99501",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        82,
        159
      ]
    }
  },
  {
    "citySlug": "fairbanks",
    "cityName": "Fairbanks",
    "stateSlug": "alaska",
    "hardness": 142,
    "populationK": 32,
    "firstZip": "99701",
    "hardnessSourcing": {
      "shape": "point",
      "value": 142
    }
  },
  {
    "citySlug": "juneau",
    "cityName": "Juneau",
    "stateSlug": "alaska",
    "hardness": 60,
    "populationK": 32,
    "firstZip": "99801",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "wasilla-palmer",
    "cityName": "Wasilla-Palmer",
    "stateSlug": "alaska",
    "hardness": 180,
    "populationK": 27,
    "firstZip": "99654",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        120,
        210
      ]
    }
  },
  {
    "citySlug": "sitka",
    "cityName": "Sitka",
    "stateSlug": "alaska",
    "hardness": 55,
    "populationK": 8,
    "firstZip": "99835",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "honolulu",
    "cityName": "Honolulu",
    "stateSlug": "hawaii",
    "hardness": 95,
    "populationK": 350,
    "firstZip": "96813",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "kailua-kaneohe",
    "cityName": "Kailua-Kaneohe",
    "stateSlug": "hawaii",
    "hardness": 120,
    "populationK": 100,
    "firstZip": "96734",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "hilo",
    "cityName": "Hilo",
    "stateSlug": "hawaii",
    "hardness": 90,
    "populationK": 45,
    "firstZip": "96720",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "kailua-kona",
    "cityName": "Kailua-Kona",
    "stateSlug": "hawaii",
    "hardness": 170,
    "populationK": 23,
    "firstZip": "96740",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "kahului-wailuku",
    "cityName": "Kahului-Wailuku",
    "stateSlug": "hawaii",
    "hardness": 130,
    "populationK": 40,
    "firstZip": "96732",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "little-rock",
    "cityName": "Little Rock",
    "stateSlug": "arkansas",
    "hardness": 120,
    "populationK": 202,
    "firstZip": "72201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "fort-smith",
    "cityName": "Fort Smith",
    "stateSlug": "arkansas",
    "hardness": 160,
    "populationK": 89,
    "firstZip": "72901",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "fayetteville",
    "cityName": "Fayetteville",
    "stateSlug": "arkansas",
    "hardness": 74,
    "populationK": 95,
    "firstZip": "72701",
    "hardnessSourcing": {
      "shape": "point",
      "value": 74
    }
  },
  {
    "citySlug": "springdale",
    "cityName": "Springdale",
    "stateSlug": "arkansas",
    "hardness": 74,
    "populationK": 87,
    "firstZip": "72762",
    "hardnessSourcing": {
      "shape": "point",
      "value": 74
    }
  },
  {
    "citySlug": "jonesboro",
    "cityName": "Jonesboro",
    "stateSlug": "arkansas",
    "hardness": 195,
    "populationK": 80,
    "firstZip": "72401",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "bridgeport",
    "cityName": "Bridgeport",
    "stateSlug": "connecticut",
    "hardness": 51,
    "populationK": 149,
    "firstZip": "06604",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        34,
        86
      ]
    }
  },
  {
    "citySlug": "stamford",
    "cityName": "Stamford",
    "stateSlug": "connecticut",
    "hardness": 51,
    "populationK": 135,
    "firstZip": "06901",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        34,
        68
      ]
    }
  },
  {
    "citySlug": "new-haven",
    "cityName": "New Haven",
    "stateSlug": "connecticut",
    "hardness": 100,
    "populationK": 134,
    "firstZip": "06510",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "hartford",
    "cityName": "Hartford",
    "stateSlug": "connecticut",
    "hardness": 100,
    "populationK": 121,
    "firstZip": "06103",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "waterbury",
    "cityName": "Waterbury",
    "stateSlug": "connecticut",
    "hardness": 110,
    "populationK": 114,
    "firstZip": "06702",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "des-moines",
    "cityName": "Des Moines",
    "stateSlug": "iowa",
    "hardness": 310,
    "populationK": 213,
    "firstZip": "50309",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "cedar-rapids",
    "cityName": "Cedar Rapids",
    "stateSlug": "iowa",
    "hardness": 125,
    "populationK": 138,
    "firstZip": "52402",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        100,
        150
      ]
    }
  },
  {
    "citySlug": "davenport",
    "cityName": "Davenport",
    "stateSlug": "iowa",
    "hardness": 243,
    "populationK": 102,
    "firstZip": "52801",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        136,
        350
      ]
    }
  },
  {
    "citySlug": "sioux-city",
    "cityName": "Sioux City",
    "stateSlug": "iowa",
    "hardness": 450,
    "populationK": 86,
    "firstZip": "51101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        350,
        550
      ]
    }
  },
  {
    "citySlug": "iowa-city",
    "cityName": "Iowa City",
    "stateSlug": "iowa",
    "hardness": 50,
    "populationK": 75,
    "firstZip": "52240",
    "hardnessSourcing": {
      "shape": "point",
      "value": 50
    }
  },
  {
    "citySlug": "louisville",
    "cityName": "Louisville",
    "stateSlug": "kentucky",
    "hardness": 128,
    "populationK": 633,
    "firstZip": "40202",
    "hardnessSourcing": {
      "shape": "point",
      "value": 128
    }
  },
  {
    "citySlug": "lexington",
    "cityName": "Lexington",
    "stateSlug": "kentucky",
    "hardness": 155,
    "populationK": 323,
    "firstZip": "40502",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        149,
        161
      ]
    }
  },
  {
    "citySlug": "bowling-green",
    "cityName": "Bowling Green",
    "stateSlug": "kentucky",
    "hardness": 150,
    "populationK": 75,
    "firstZip": "42101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 150
    }
  },
  {
    "citySlug": "owensboro",
    "cityName": "Owensboro",
    "stateSlug": "kentucky",
    "hardness": 125,
    "populationK": 60,
    "firstZip": "42301",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "covington",
    "cityName": "Covington",
    "stateSlug": "kentucky",
    "hardness": 122,
    "populationK": 41,
    "firstZip": "41011",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        88,
        156
      ]
    }
  },
  {
    "citySlug": "new-orleans",
    "cityName": "New Orleans",
    "stateSlug": "louisiana",
    "hardness": 115,
    "populationK": 364,
    "firstZip": "70112",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "baton-rouge",
    "cityName": "Baton Rouge",
    "stateSlug": "louisiana",
    "hardness": 160,
    "populationK": 222,
    "firstZip": "70802",
    "hardnessSourcing": {
      "shape": "qualitative"
    }
  },
  {
    "citySlug": "shreveport",
    "cityName": "Shreveport",
    "stateSlug": "louisiana",
    "hardness": 24,
    "populationK": 184,
    "firstZip": "71101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 23.5
    }
  },
  {
    "citySlug": "lafayette",
    "cityName": "Lafayette",
    "stateSlug": "louisiana",
    "hardness": 167,
    "populationK": 121,
    "firstZip": "70501",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "lake-charles",
    "cityName": "Lake Charles",
    "stateSlug": "louisiana",
    "hardness": 80,
    "populationK": 84,
    "firstZip": "70601",
    "hardnessSourcing": {
      "shape": "point",
      "value": 79.9
    }
  },
  {
    "citySlug": "baltimore",
    "cityName": "Baltimore",
    "stateSlug": "maryland",
    "hardness": 100,
    "populationK": 570,
    "firstZip": "21201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        76,
        120
      ]
    }
  },
  {
    "citySlug": "columbia",
    "cityName": "Columbia",
    "stateSlug": "maryland",
    "hardness": 145,
    "populationK": 105,
    "firstZip": "21044",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "germantown",
    "cityName": "Germantown",
    "stateSlug": "maryland",
    "hardness": 154,
    "populationK": 91,
    "firstZip": "20874",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        79,
        213
      ]
    }
  },
  {
    "citySlug": "waldorf",
    "cityName": "Waldorf",
    "stateSlug": "maryland",
    "hardness": 160,
    "populationK": 81,
    "firstZip": "20601",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "silver-spring",
    "cityName": "Silver Spring",
    "stateSlug": "maryland",
    "hardness": 112,
    "populationK": 81,
    "firstZip": "20901",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        58,
        213
      ]
    }
  },
  {
    "citySlug": "minneapolis",
    "cityName": "Minneapolis",
    "stateSlug": "minnesota",
    "hardness": 94,
    "populationK": 425,
    "firstZip": "55401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        83,
        106
      ]
    }
  },
  {
    "citySlug": "saint-paul",
    "cityName": "Saint Paul",
    "stateSlug": "minnesota",
    "hardness": 91,
    "populationK": 311,
    "firstZip": "55101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 91
    }
  },
  {
    "citySlug": "rochester",
    "cityName": "Rochester",
    "stateSlug": "minnesota",
    "hardness": 283,
    "populationK": 121,
    "firstZip": "55901",
    "hardnessSourcing": {
      "shape": "point",
      "value": 283
    }
  },
  {
    "citySlug": "bloomington",
    "cityName": "Bloomington",
    "stateSlug": "minnesota",
    "hardness": 89,
    "populationK": 89,
    "firstZip": "55420",
    "hardnessSourcing": {
      "shape": "point",
      "value": 89
    }
  },
  {
    "citySlug": "duluth",
    "cityName": "Duluth",
    "stateSlug": "minnesota",
    "hardness": 44,
    "populationK": 86,
    "firstZip": "55802",
    "hardnessSourcing": {
      "shape": "point",
      "value": 44
    }
  },
  {
    "citySlug": "las-vegas",
    "cityName": "Las Vegas",
    "stateSlug": "nevada",
    "hardness": 291,
    "populationK": 656,
    "firstZip": "89101",
    "hardnessSourcing": {
      "shape": "point",
      "value": 291
    }
  },
  {
    "citySlug": "henderson",
    "cityName": "Henderson",
    "stateSlug": "nevada",
    "hardness": 304,
    "populationK": 322,
    "firstZip": "89002",
    "hardnessSourcing": {
      "shape": "point",
      "value": 304
    }
  },
  {
    "citySlug": "reno",
    "cityName": "Reno",
    "stateSlug": "nevada",
    "hardness": 135,
    "populationK": 264,
    "firstZip": "89501",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        32,
        238
      ]
    }
  },
  {
    "citySlug": "north-las-vegas",
    "cityName": "North Las Vegas",
    "stateSlug": "nevada",
    "hardness": 280,
    "populationK": 252,
    "firstZip": "89030",
    "hardnessSourcing": {
      "shape": "point",
      "value": 280
    }
  },
  {
    "citySlug": "sparks",
    "cityName": "Sparks",
    "stateSlug": "nevada",
    "hardness": 80,
    "populationK": 108,
    "firstZip": "89431",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        68,
        92
      ]
    }
  },
  {
    "citySlug": "oklahoma-city",
    "cityName": "Oklahoma City",
    "stateSlug": "oklahoma",
    "hardness": 180,
    "populationK": 681,
    "firstZip": "73102",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "tulsa",
    "cityName": "Tulsa",
    "stateSlug": "oklahoma",
    "hardness": 115,
    "populationK": 411,
    "firstZip": "74103",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        89,
        140
      ]
    }
  },
  {
    "citySlug": "norman",
    "cityName": "Norman",
    "stateSlug": "oklahoma",
    "hardness": 180,
    "populationK": 128,
    "firstZip": "73069",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "broken-arrow",
    "cityName": "Broken Arrow",
    "stateSlug": "oklahoma",
    "hardness": 110,
    "populationK": 117,
    "firstZip": "74011",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "edmond",
    "cityName": "Edmond",
    "stateSlug": "oklahoma",
    "hardness": 175,
    "populationK": 96,
    "firstZip": "73003",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "portland",
    "cityName": "Portland",
    "stateSlug": "oregon",
    "hardness": 7,
    "populationK": 652,
    "firstZip": "97201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        7,
        68
      ]
    }
  },
  {
    "citySlug": "eugene",
    "cityName": "Eugene",
    "stateSlug": "oregon",
    "hardness": 17,
    "populationK": 176,
    "firstZip": "97401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        16,
        18
      ]
    }
  },
  {
    "citySlug": "salem",
    "cityName": "Salem",
    "stateSlug": "oregon",
    "hardness": 45,
    "populationK": 175,
    "firstZip": "97301",
    "hardnessSourcing": {
      "shape": "unlocated"
    }
  },
  {
    "citySlug": "bend",
    "cityName": "Bend",
    "stateSlug": "oregon",
    "hardness": 21,
    "populationK": 105,
    "firstZip": "97701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        17,
        25
      ]
    }
  },
  {
    "citySlug": "gresham",
    "cityName": "Gresham",
    "stateSlug": "oregon",
    "hardness": 32,
    "populationK": 113,
    "firstZip": "97030",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "charleston",
    "cityName": "Charleston",
    "stateSlug": "south-carolina",
    "hardness": 55,
    "populationK": 150,
    "firstZip": "29401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        54,
        56
      ]
    }
  },
  {
    "citySlug": "columbia",
    "cityName": "Columbia",
    "stateSlug": "south-carolina",
    "hardness": 36,
    "populationK": 137,
    "firstZip": "29201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        20,
        47
      ]
    }
  },
  {
    "citySlug": "north-charleston",
    "cityName": "North Charleston",
    "stateSlug": "south-carolina",
    "hardness": 55,
    "populationK": 119,
    "firstZip": "29405",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        54,
        56
      ]
    }
  },
  {
    "citySlug": "mount-pleasant",
    "cityName": "Mount Pleasant",
    "stateSlug": "south-carolina",
    "hardness": 90,
    "populationK": 96,
    "firstZip": "29464",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "rock-hill",
    "cityName": "Rock Hill",
    "stateSlug": "south-carolina",
    "hardness": 25,
    "populationK": 75,
    "firstZip": "29730",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        18,
        32
      ]
    }
  },
  {
    "citySlug": "salt-lake-city",
    "cityName": "Salt Lake City",
    "stateSlug": "utah",
    "hardness": 175,
    "populationK": 209,
    "firstZip": "84101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        136,
        571
      ]
    }
  },
  {
    "citySlug": "west-valley-city",
    "cityName": "West Valley City",
    "stateSlug": "utah",
    "hardness": 176,
    "populationK": 140,
    "firstZip": "84119",
    "hardnessSourcing": {
      "shape": "point",
      "value": 176
    }
  },
  {
    "citySlug": "west-jordan",
    "cityName": "West Jordan",
    "stateSlug": "utah",
    "hardness": 183,
    "populationK": 117,
    "firstZip": "84084",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        16,
        602
      ]
    }
  },
  {
    "citySlug": "provo",
    "cityName": "Provo",
    "stateSlug": "utah",
    "hardness": 214,
    "populationK": 116,
    "firstZip": "84601",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        171,
        257
      ]
    }
  },
  {
    "citySlug": "orem",
    "cityName": "Orem",
    "stateSlug": "utah",
    "hardness": 250,
    "populationK": 98,
    "firstZip": "84057",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        112,
        428
      ]
    }
  },
  {
    "citySlug": "huntsville",
    "cityName": "Huntsville",
    "stateSlug": "alabama",
    "hardness": 108,
    "populationK": 225,
    "firstZip": "35801",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        68,
        149
      ]
    }
  },
  {
    "citySlug": "birmingham",
    "cityName": "Birmingham",
    "stateSlug": "alabama",
    "hardness": 98,
    "populationK": 197,
    "firstZip": "35203",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        40,
        156
      ]
    }
  },
  {
    "citySlug": "montgomery",
    "cityName": "Montgomery",
    "stateSlug": "alabama",
    "hardness": 41,
    "populationK": 197,
    "firstZip": "36104",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        4,
        115
      ]
    }
  },
  {
    "citySlug": "mobile",
    "cityName": "Mobile",
    "stateSlug": "alabama",
    "hardness": 44,
    "populationK": 184,
    "firstZip": "36602",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        38.3,
        49.6
      ]
    }
  },
  {
    "citySlug": "tuscaloosa",
    "cityName": "Tuscaloosa",
    "stateSlug": "alabama",
    "hardness": 95,
    "populationK": 111,
    "firstZip": "35401",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "milwaukee",
    "cityName": "Milwaukee",
    "stateSlug": "wisconsin",
    "hardness": 137,
    "populationK": 561,
    "firstZip": "53202",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        112,
        142
      ]
    }
  },
  {
    "citySlug": "madison",
    "cityName": "Madison",
    "stateSlug": "wisconsin",
    "hardness": 325,
    "populationK": 270,
    "firstZip": "53703",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        308,
        342
      ]
    }
  },
  {
    "citySlug": "green-bay",
    "cityName": "Green Bay",
    "stateSlug": "wisconsin",
    "hardness": 130,
    "populationK": 107,
    "firstZip": "54301",
    "hardnessSourcing": {
      "shape": "point",
      "value": 130
    }
  },
  {
    "citySlug": "kenosha",
    "cityName": "Kenosha",
    "stateSlug": "wisconsin",
    "hardness": 140,
    "populationK": 100,
    "firstZip": "53140",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        131,
        148
      ]
    }
  },
  {
    "citySlug": "racine",
    "cityName": "Racine",
    "stateSlug": "wisconsin",
    "hardness": 140,
    "populationK": 77,
    "firstZip": "53402",
    "hardnessSourcing": {
      "shape": "point",
      "value": 140
    }
  },
  {
    "citySlug": "denver",
    "cityName": "Denver",
    "stateSlug": "colorado",
    "hardness": 77,
    "populationK": 716,
    "firstZip": "80202",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        34,
        120
      ]
    }
  },
  {
    "citySlug": "colorado-springs",
    "cityName": "Colorado Springs",
    "stateSlug": "colorado",
    "hardness": 155,
    "populationK": 488,
    "firstZip": "80903",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "aurora",
    "cityName": "Aurora",
    "stateSlug": "colorado",
    "hardness": 136,
    "populationK": 398,
    "firstZip": "80010",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        87,
        198
      ]
    }
  },
  {
    "citySlug": "fort-collins",
    "cityName": "Fort Collins",
    "stateSlug": "colorado",
    "hardness": 45,
    "populationK": 174,
    "firstZip": "80521",
    "hardnessSourcing": {
      "shape": "qualitative",
      "operatorWord": "naturally soft"
    }
  },
  {
    "citySlug": "boulder",
    "cityName": "Boulder",
    "stateSlug": "colorado",
    "hardness": 42,
    "populationK": 105,
    "firstZip": "80301",
    "hardnessSourcing": {
      "shape": "point",
      "value": 42
    }
  },
  {
    "citySlug": "kansas-city",
    "cityName": "Kansas City",
    "stateSlug": "missouri",
    "hardness": 100,
    "populationK": 508,
    "firstZip": "64108",
    "hardnessSourcing": {
      "shape": "point",
      "value": 100
    }
  },
  {
    "citySlug": "st-louis",
    "cityName": "St. Louis",
    "stateSlug": "missouri",
    "hardness": 129,
    "populationK": 287,
    "firstZip": "63101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        80,
        206
      ]
    }
  },
  {
    "citySlug": "springfield",
    "cityName": "Springfield",
    "stateSlug": "missouri",
    "hardness": 137,
    "populationK": 169,
    "firstZip": "65802",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        74,
        206
      ]
    }
  },
  {
    "citySlug": "columbia",
    "cityName": "Columbia",
    "stateSlug": "missouri",
    "hardness": 187,
    "populationK": 126,
    "firstZip": "65201",
    "hardnessSourcing": {
      "shape": "point",
      "value": 187
    }
  },
  {
    "citySlug": "independence",
    "cityName": "Independence",
    "stateSlug": "missouri",
    "hardness": 123,
    "populationK": 123,
    "firstZip": "64050",
    "hardnessSourcing": {
      "shape": "point",
      "value": 123
    }
  },
  {
    "citySlug": "nashville",
    "cityName": "Nashville",
    "stateSlug": "tennessee",
    "hardness": 78,
    "populationK": 689,
    "firstZip": "37201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        62,
        113
      ]
    }
  },
  {
    "citySlug": "memphis",
    "cityName": "Memphis",
    "stateSlug": "tennessee",
    "hardness": 48,
    "populationK": 633,
    "firstZip": "38103",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        12,
        130
      ]
    }
  },
  {
    "citySlug": "knoxville",
    "cityName": "Knoxville",
    "stateSlug": "tennessee",
    "hardness": 91,
    "populationK": 199,
    "firstZip": "37902",
    "hardnessSourcing": {
      "shape": "point",
      "value": 91
    }
  },
  {
    "citySlug": "chattanooga",
    "cityName": "Chattanooga",
    "stateSlug": "tennessee",
    "hardness": 72,
    "populationK": 184,
    "firstZip": "37402",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        54,
        90
      ]
    }
  },
  {
    "citySlug": "clarksville",
    "cityName": "Clarksville",
    "stateSlug": "tennessee",
    "hardness": 97,
    "populationK": 167,
    "firstZip": "37040",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        78,
        132
      ]
    }
  },
  {
    "citySlug": "phoenix",
    "cityName": "Phoenix",
    "stateSlug": "arizona",
    "hardness": 251,
    "populationK": 1660,
    "firstZip": "85003",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        158,
        344
      ]
    }
  },
  {
    "citySlug": "tucson",
    "cityName": "Tucson",
    "stateSlug": "arizona",
    "hardness": 260,
    "populationK": 547,
    "firstZip": "85701",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "mesa",
    "cityName": "Mesa",
    "stateSlug": "arizona",
    "hardness": 290,
    "populationK": 511,
    "firstZip": "85201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        205,
        376
      ]
    }
  },
  {
    "citySlug": "scottsdale",
    "cityName": "Scottsdale",
    "stateSlug": "arizona",
    "hardness": 253,
    "populationK": 243,
    "firstZip": "85250",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        215,
        290
      ]
    }
  },
  {
    "citySlug": "chandler",
    "cityName": "Chandler",
    "stateSlug": "arizona",
    "hardness": 230,
    "populationK": 281,
    "firstZip": "85224",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        173,
        288
      ]
    }
  },
  {
    "citySlug": "flagstaff",
    "cityName": "Flagstaff",
    "stateSlug": "arizona",
    "hardness": 145,
    "populationK": 78,
    "firstZip": "86001",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "los-angeles",
    "cityName": "Los Angeles",
    "stateSlug": "california",
    "hardness": 220,
    "populationK": 3899,
    "firstZip": "90001",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        93,
        275
      ]
    }
  },
  {
    "citySlug": "san-diego",
    "cityName": "San Diego",
    "stateSlug": "california",
    "hardness": 247,
    "populationK": 1388,
    "firstZip": "92101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        209,
        284
      ]
    }
  },
  {
    "citySlug": "san-jose",
    "cityName": "San Jose",
    "stateSlug": "california",
    "hardness": 240,
    "populationK": 969,
    "firstZip": "95110",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        77,
        440
      ]
    }
  },
  {
    "citySlug": "san-francisco",
    "cityName": "San Francisco",
    "stateSlug": "california",
    "hardness": 62,
    "populationK": 808,
    "firstZip": "94102",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        8.1,
        112
      ]
    }
  },
  {
    "citySlug": "fresno",
    "cityName": "Fresno",
    "stateSlug": "california",
    "hardness": 129,
    "populationK": 545,
    "firstZip": "93701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        87,
        150
      ]
    }
  },
  {
    "citySlug": "oakland",
    "cityName": "Oakland",
    "stateSlug": "california",
    "hardness": 85,
    "populationK": 440,
    "firstZip": "94601",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        12,
        160
      ]
    }
  },
  {
    "citySlug": "jacksonville",
    "cityName": "Jacksonville",
    "stateSlug": "florida",
    "hardness": 250,
    "populationK": 988,
    "firstZip": "32202",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        120,
        341
      ]
    }
  },
  {
    "citySlug": "miami",
    "cityName": "Miami",
    "stateSlug": "florida",
    "hardness": 195,
    "populationK": 455,
    "firstZip": "33125",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "tampa",
    "cityName": "Tampa",
    "stateSlug": "florida",
    "hardness": 186,
    "populationK": 403,
    "firstZip": "33602",
    "hardnessSourcing": {
      "shape": "point",
      "value": 186
    }
  },
  {
    "citySlug": "orlando",
    "cityName": "Orlando",
    "stateSlug": "florida",
    "hardness": 129,
    "populationK": 318,
    "firstZip": "32801",
    "hardnessSourcing": {
      "shape": "point",
      "value": 129
    }
  },
  {
    "citySlug": "st-petersburg",
    "cityName": "St. Petersburg",
    "stateSlug": "florida",
    "hardness": 158,
    "populationK": 263,
    "firstZip": "33701",
    "hardnessSourcing": {
      "shape": "point",
      "value": 158
    }
  },
  {
    "citySlug": "hialeah",
    "cityName": "Hialeah",
    "stateSlug": "florida",
    "hardness": 200,
    "populationK": 217,
    "firstZip": "33010",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "atlanta",
    "cityName": "Atlanta",
    "stateSlug": "georgia",
    "hardness": 85,
    "populationK": 499,
    "firstZip": "30301",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "augusta",
    "cityName": "Augusta",
    "stateSlug": "georgia",
    "hardness": 110,
    "populationK": 202,
    "firstZip": "30901",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "columbus",
    "cityName": "Columbus",
    "stateSlug": "georgia",
    "hardness": 95,
    "populationK": 206,
    "firstZip": "31901",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "savannah",
    "cityName": "Savannah",
    "stateSlug": "georgia",
    "hardness": 195,
    "populationK": 147,
    "firstZip": "31401",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "athens",
    "cityName": "Athens",
    "stateSlug": "georgia",
    "hardness": 75,
    "populationK": 127,
    "firstZip": "30601",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "marietta",
    "cityName": "Marietta",
    "stateSlug": "georgia",
    "hardness": 32,
    "populationK": 60,
    "firstZip": "30060",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        31.2,
        33.4
      ]
    }
  },
  {
    "citySlug": "chicago",
    "cityName": "Chicago",
    "stateSlug": "illinois",
    "hardness": 135,
    "populationK": 2664,
    "firstZip": "60601",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        126,
        143
      ]
    }
  },
  {
    "citySlug": "aurora",
    "cityName": "Aurora",
    "stateSlug": "illinois",
    "hardness": 135,
    "populationK": 180,
    "firstZip": "60504",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        110,
        160
      ]
    }
  },
  {
    "citySlug": "naperville",
    "cityName": "Naperville",
    "stateSlug": "illinois",
    "hardness": 135,
    "populationK": 150,
    "firstZip": "60540",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "joliet",
    "cityName": "Joliet",
    "stateSlug": "illinois",
    "hardness": 325,
    "populationK": 151,
    "firstZip": "60431",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "rockford",
    "cityName": "Rockford",
    "stateSlug": "illinois",
    "hardness": 270,
    "populationK": 147,
    "firstZip": "61101",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "springfield",
    "cityName": "Springfield",
    "stateSlug": "illinois",
    "hardness": 99,
    "populationK": 113,
    "firstZip": "62701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        80,
        142
      ]
    }
  },
  {
    "citySlug": "indianapolis",
    "cityName": "Indianapolis",
    "stateSlug": "indiana",
    "hardness": 320,
    "populationK": 881,
    "firstZip": "46202",
    "hardnessSourcing": {
      "shape": "point",
      "value": 320
    }
  },
  {
    "citySlug": "fort-wayne",
    "cityName": "Fort Wayne",
    "stateSlug": "indiana",
    "hardness": 130,
    "populationK": 264,
    "firstZip": "46802",
    "hardnessSourcing": {
      "shape": "point",
      "value": 130
    }
  },
  {
    "citySlug": "evansville",
    "cityName": "Evansville",
    "stateSlug": "indiana",
    "hardness": 130,
    "populationK": 116,
    "firstZip": "47708",
    "hardnessSourcing": {
      "shape": "point",
      "value": 130
    }
  },
  {
    "citySlug": "carmel",
    "cityName": "Carmel",
    "stateSlug": "indiana",
    "hardness": 228,
    "populationK": 100,
    "firstZip": "46032",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        68,
        633
      ]
    }
  },
  {
    "citySlug": "fishers",
    "cityName": "Fishers",
    "stateSlug": "indiana",
    "hardness": 320,
    "populationK": 99,
    "firstZip": "46037",
    "hardnessSourcing": {
      "shape": "point",
      "value": 320
    }
  },
  {
    "citySlug": "hammond",
    "cityName": "Hammond",
    "stateSlug": "indiana",
    "hardness": 150,
    "populationK": 76,
    "firstZip": "46320",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "bloomington",
    "cityName": "Bloomington",
    "stateSlug": "indiana",
    "hardness": 50,
    "populationK": 79,
    "firstZip": "47401",
    "hardnessSourcing": {
      "shape": "point",
      "value": 50
    }
  },
  {
    "citySlug": "gary",
    "cityName": "Gary",
    "stateSlug": "indiana",
    "hardness": 140,
    "populationK": 68,
    "firstZip": "46402",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        130,
        150
      ]
    }
  },
  {
    "citySlug": "boston",
    "cityName": "Boston",
    "stateSlug": "massachusetts",
    "hardness": 10,
    "populationK": 654,
    "firstZip": "02108",
    "hardnessSourcing": {
      "shape": "point",
      "value": 10
    }
  },
  {
    "citySlug": "worcester",
    "cityName": "Worcester",
    "stateSlug": "massachusetts",
    "hardness": 30,
    "populationK": 207,
    "firstZip": "01602",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        22,
        55
      ]
    }
  },
  {
    "citySlug": "springfield",
    "cityName": "Springfield",
    "stateSlug": "massachusetts",
    "hardness": 12,
    "populationK": 154,
    "firstZip": "01103",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        10,
        14
      ]
    }
  },
  {
    "citySlug": "cambridge",
    "cityName": "Cambridge",
    "stateSlug": "massachusetts",
    "hardness": 35,
    "populationK": 118,
    "firstZip": "02138",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "lowell",
    "cityName": "Lowell",
    "stateSlug": "massachusetts",
    "hardness": 65,
    "populationK": 115,
    "firstZip": "01850",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "new-bedford",
    "cityName": "New Bedford",
    "stateSlug": "massachusetts",
    "hardness": 13,
    "populationK": 102,
    "firstZip": "02740",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "detroit",
    "cityName": "Detroit",
    "stateSlug": "michigan",
    "hardness": 110,
    "populationK": 633,
    "firstZip": "48201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        96,
        142
      ]
    }
  },
  {
    "citySlug": "grand-rapids",
    "cityName": "Grand Rapids",
    "stateSlug": "michigan",
    "hardness": 142,
    "populationK": 199,
    "firstZip": "49503",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        126,
        164
      ]
    }
  },
  {
    "citySlug": "warren",
    "cityName": "Warren",
    "stateSlug": "michigan",
    "hardness": 105,
    "populationK": 138,
    "firstZip": "48088",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        96,
        120
      ]
    }
  },
  {
    "citySlug": "sterling-heights",
    "cityName": "Sterling Heights",
    "stateSlug": "michigan",
    "hardness": 110,
    "populationK": 134,
    "firstZip": "48310",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "ann-arbor",
    "cityName": "Ann Arbor",
    "stateSlug": "michigan",
    "hardness": 126,
    "populationK": 124,
    "firstZip": "48103",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        74,
        180
      ]
    }
  },
  {
    "citySlug": "lansing",
    "cityName": "Lansing",
    "stateSlug": "michigan",
    "hardness": 98,
    "populationK": 113,
    "firstZip": "48906",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        89,
        120
      ]
    }
  },
  {
    "citySlug": "newark",
    "cityName": "Newark",
    "stateSlug": "new-jersey",
    "hardness": 53,
    "populationK": 305,
    "firstZip": "07102",
    "hardnessSourcing": {
      "shape": "point",
      "value": 52.6
    }
  },
  {
    "citySlug": "jersey-city",
    "cityName": "Jersey City",
    "stateSlug": "new-jersey",
    "hardness": 75,
    "populationK": 292,
    "firstZip": "07302",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        57,
        92
      ]
    }
  },
  {
    "citySlug": "paterson",
    "cityName": "Paterson",
    "stateSlug": "new-jersey",
    "hardness": 125,
    "populationK": 159,
    "firstZip": "07501",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        70,
        140
      ]
    }
  },
  {
    "citySlug": "princeton",
    "cityName": "Princeton",
    "stateSlug": "new-jersey",
    "hardness": 145,
    "populationK": 31,
    "firstZip": "08540",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        90,
        222
      ]
    }
  },
  {
    "citySlug": "trenton",
    "cityName": "Trenton",
    "stateSlug": "new-jersey",
    "hardness": 80,
    "populationK": 90,
    "firstZip": "08608",
    "hardnessSourcing": {
      "shape": "point",
      "value": 80.1
    }
  },
  {
    "citySlug": "cherry-hill",
    "cityName": "Cherry Hill",
    "stateSlug": "new-jersey",
    "hardness": 128,
    "populationK": 74,
    "firstZip": "08002",
    "hardnessSourcing": {
      "shape": "point",
      "value": 128
    }
  },
  {
    "citySlug": "new-york-city",
    "cityName": "New York City",
    "stateSlug": "new-york",
    "hardness": 50,
    "populationK": 8336,
    "firstZip": "10001",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        31,
        120
      ]
    }
  },
  {
    "citySlug": "buffalo",
    "cityName": "Buffalo",
    "stateSlug": "new-york",
    "hardness": 89,
    "populationK": 277,
    "firstZip": "14201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        80,
        100
      ]
    }
  },
  {
    "citySlug": "yonkers",
    "cityName": "Yonkers",
    "stateSlug": "new-york",
    "hardness": 65,
    "populationK": 211,
    "firstZip": "10701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        31,
        120
      ]
    }
  },
  {
    "citySlug": "rochester",
    "cityName": "Rochester",
    "stateSlug": "new-york",
    "hardness": 115,
    "populationK": 211,
    "firstZip": "14604",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        88,
        120
      ]
    }
  },
  {
    "citySlug": "syracuse",
    "cityName": "Syracuse",
    "stateSlug": "new-york",
    "hardness": 127,
    "populationK": 145,
    "firstZip": "13202",
    "hardnessSourcing": {
      "shape": "point",
      "value": 127
    }
  },
  {
    "citySlug": "hempstead",
    "cityName": "Hempstead",
    "stateSlug": "new-york",
    "hardness": 27,
    "populationK": 798,
    "firstZip": "11550",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        22,
        33
      ]
    }
  },
  {
    "citySlug": "charlotte",
    "cityName": "Charlotte",
    "stateSlug": "north-carolina",
    "hardness": 32,
    "populationK": 911,
    "firstZip": "28202",
    "hardnessSourcing": {
      "shape": "point",
      "value": 32
    }
  },
  {
    "citySlug": "raleigh",
    "cityName": "Raleigh",
    "stateSlug": "north-carolina",
    "hardness": 25,
    "populationK": 480,
    "firstZip": "27601",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        24.7,
        25.5
      ]
    }
  },
  {
    "citySlug": "greensboro",
    "cityName": "Greensboro",
    "stateSlug": "north-carolina",
    "hardness": 43,
    "populationK": 301,
    "firstZip": "27401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        34,
        51
      ]
    }
  },
  {
    "citySlug": "durham",
    "cityName": "Durham",
    "stateSlug": "north-carolina",
    "hardness": 24,
    "populationK": 290,
    "firstZip": "27701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        23,
        24
      ]
    }
  },
  {
    "citySlug": "cary",
    "cityName": "Cary",
    "stateSlug": "north-carolina",
    "hardness": 28,
    "populationK": 180,
    "firstZip": "27511",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        25,
        30
      ]
    }
  },
  {
    "citySlug": "asheville",
    "cityName": "Asheville",
    "stateSlug": "north-carolina",
    "hardness": 5.52,
    "populationK": 95,
    "firstZip": "28801",
    "hardnessSourcing": {
      "shape": "point",
      "value": 5.52
    }
  },
  {
    "citySlug": "wilmington",
    "cityName": "Wilmington",
    "stateSlug": "north-carolina",
    "hardness": 50,
    "populationK": 121,
    "firstZip": "28401",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        39,
        62
      ]
    }
  },
  {
    "citySlug": "columbus",
    "cityName": "Columbus",
    "stateSlug": "ohio",
    "hardness": 120,
    "populationK": 913,
    "firstZip": "43201",
    "hardnessSourcing": {
      "shape": "point",
      "value": 120
    }
  },
  {
    "citySlug": "cleveland",
    "cityName": "Cleveland",
    "stateSlug": "ohio",
    "hardness": 117,
    "populationK": 367,
    "firstZip": "44103",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        105,
        130
      ]
    }
  },
  {
    "citySlug": "cincinnati",
    "cityName": "Cincinnati",
    "stateSlug": "ohio",
    "hardness": 133,
    "populationK": 309,
    "firstZip": "45202",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        126,
        140
      ]
    }
  },
  {
    "citySlug": "toledo",
    "cityName": "Toledo",
    "stateSlug": "ohio",
    "hardness": 135,
    "populationK": 264,
    "firstZip": "43604",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "akron",
    "cityName": "Akron",
    "stateSlug": "ohio",
    "hardness": 107,
    "populationK": 188,
    "firstZip": "44301",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        76,
        150
      ]
    }
  },
  {
    "citySlug": "dayton",
    "cityName": "Dayton",
    "stateSlug": "ohio",
    "hardness": 155,
    "populationK": 137,
    "firstZip": "45402",
    "hardnessSourcing": {
      "shape": "point",
      "value": 155
    }
  },
  {
    "citySlug": "philadelphia",
    "cityName": "Philadelphia",
    "stateSlug": "pennsylvania",
    "hardness": 120,
    "populationK": 1567,
    "firstZip": "19102",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        90,
        150
      ]
    }
  },
  {
    "citySlug": "pittsburgh",
    "cityName": "Pittsburgh",
    "stateSlug": "pennsylvania",
    "hardness": 125,
    "populationK": 303,
    "firstZip": "15203",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "allentown",
    "cityName": "Allentown",
    "stateSlug": "pennsylvania",
    "hardness": 257,
    "populationK": 126,
    "firstZip": "18101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        180,
        284
      ]
    }
  },
  {
    "citySlug": "erie",
    "cityName": "Erie",
    "stateSlug": "pennsylvania",
    "hardness": 135,
    "populationK": 92,
    "firstZip": "16501",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "reading",
    "cityName": "Reading",
    "stateSlug": "pennsylvania",
    "hardness": 195,
    "populationK": 95,
    "firstZip": "19601",
    "hardnessSourcing": {
      "shape": "unlocated"
    }
  },
  {
    "citySlug": "lancaster",
    "cityName": "Lancaster",
    "stateSlug": "pennsylvania",
    "hardness": 161,
    "populationK": 58,
    "firstZip": "17602",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        99,
        223
      ]
    }
  },
  {
    "citySlug": "houston",
    "cityName": "Houston",
    "stateSlug": "texas",
    "hardness": 136,
    "populationK": 2305,
    "firstZip": "77002",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        44,
        229
      ]
    }
  },
  {
    "citySlug": "san-antonio",
    "cityName": "San Antonio",
    "stateSlug": "texas",
    "hardness": 300,
    "populationK": 1495,
    "firstZip": "78201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        257,
        342
      ]
    }
  },
  {
    "citySlug": "dallas",
    "cityName": "Dallas",
    "stateSlug": "texas",
    "hardness": 235,
    "populationK": 1304,
    "firstZip": "75201",
    "hardnessSourcing": {
      "shape": "unpublished"
    }
  },
  {
    "citySlug": "austin",
    "cityName": "Austin",
    "stateSlug": "texas",
    "hardness": 98,
    "populationK": 974,
    "firstZip": "78701",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        70,
        126
      ]
    }
  },
  {
    "citySlug": "fort-worth",
    "cityName": "Fort Worth",
    "stateSlug": "texas",
    "hardness": 130,
    "populationK": 957,
    "firstZip": "76102",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        76.5,
        183
      ]
    }
  },
  {
    "citySlug": "el-paso",
    "cityName": "El Paso",
    "stateSlug": "texas",
    "hardness": 175,
    "populationK": 678,
    "firstZip": "79901",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        63,
        236
      ]
    }
  },
  {
    "citySlug": "virginia-beach",
    "cityName": "Virginia Beach",
    "stateSlug": "virginia",
    "hardness": 56,
    "populationK": 459,
    "firstZip": "23451",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        48,
        74
      ]
    }
  },
  {
    "citySlug": "chesapeake",
    "cityName": "Chesapeake",
    "stateSlug": "virginia",
    "hardness": 53,
    "populationK": 251,
    "firstZip": "23320",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        32,
        74
      ]
    }
  },
  {
    "citySlug": "arlington",
    "cityName": "Arlington",
    "stateSlug": "virginia",
    "hardness": 142,
    "populationK": 239,
    "firstZip": "22201",
    "hardnessSourcing": {
      "shape": "point",
      "value": 142
    }
  },
  {
    "citySlug": "norfolk",
    "cityName": "Norfolk",
    "stateSlug": "virginia",
    "hardness": 48,
    "populationK": 238,
    "firstZip": "23502",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        32,
        74
      ]
    }
  },
  {
    "citySlug": "richmond",
    "cityName": "Richmond",
    "stateSlug": "virginia",
    "hardness": 81,
    "populationK": 227,
    "firstZip": "23219",
    "hardnessSourcing": {
      "shape": "point",
      "value": 81
    }
  },
  {
    "citySlug": "newport-news",
    "cityName": "Newport News",
    "stateSlug": "virginia",
    "hardness": 69,
    "populationK": 186,
    "firstZip": "23601",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        63,
        75
      ]
    }
  },
  {
    "citySlug": "alexandria",
    "cityName": "Alexandria",
    "stateSlug": "virginia",
    "hardness": 130,
    "populationK": 159,
    "firstZip": "22301",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        78,
        191
      ]
    }
  },
  {
    "citySlug": "hampton",
    "cityName": "Hampton",
    "stateSlug": "virginia",
    "hardness": 69,
    "populationK": 137,
    "firstZip": "23661",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        63,
        75
      ]
    }
  },
  {
    "citySlug": "seattle",
    "cityName": "Seattle",
    "stateSlug": "washington",
    "hardness": 28,
    "populationK": 750,
    "firstZip": "98101",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        24,
        32
      ]
    }
  },
  {
    "citySlug": "spokane",
    "cityName": "Spokane",
    "stateSlug": "washington",
    "hardness": 134,
    "populationK": 230,
    "firstZip": "99201",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        90.6,
        360
      ]
    }
  },
  {
    "citySlug": "tacoma",
    "cityName": "Tacoma",
    "stateSlug": "washington",
    "hardness": 26,
    "populationK": 220,
    "firstZip": "98402",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        17,
        34
      ]
    }
  },
  {
    "citySlug": "vancouver",
    "cityName": "Vancouver",
    "stateSlug": "washington",
    "hardness": 110,
    "populationK": 200,
    "firstZip": "98660",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        79,
        140
      ]
    }
  },
  {
    "citySlug": "bellevue",
    "cityName": "Bellevue",
    "stateSlug": "washington",
    "hardness": 28,
    "populationK": 152,
    "firstZip": "98004",
    "hardnessSourcing": {
      "shape": "range",
      "range": [
        24,
        32
      ]
    }
  },
  {
    "citySlug": "yakima",
    "cityName": "Yakima",
    "stateSlug": "washington",
    "hardness": 27.4,
    "populationK": 97,
    "firstZip": "98901",
    "hardnessSourcing": {
      "shape": "point",
      "value": 27.4
    }
  }
];

// Convenience accessors that operate on the lightweight index only.
// Listing surfaces should use these — they avoid loading any per-state
// city module.

// Returns the lightweight summary for a city, or null if no city with
// that (stateSlug, citySlug) pair has a dedicated page.
export function getCitySummaryBySlug(stateSlug, citySlug) {
  return CITIES_INDEX.find(
    (c) => c.stateSlug === stateSlug && c.citySlug === citySlug,
  ) || null;
}

// Returns the lightweight summaries for every city in the given state,
// in declaration order. Used by StatePage's cities-we-cover grid and
// by CityPage's sibling-cities grid (which then filters out the focused
// city).
export function getCitySummariesByState(stateSlug) {
  return CITIES_INDEX.filter((c) => c.stateSlug === stateSlug);
}

// Returns every (stateSlug, citySlug) pair. Used by build-time tooling
// that needs the full slug inventory (e.g. the sitemap plugin reads
// these via filesystem glob now, but this in-memory accessor is kept
// for any runtime caller that wants the inventory at hand).
export function getAllCitySlugs() {
  return CITIES_INDEX.map((c) => ({ stateSlug: c.stateSlug, citySlug: c.citySlug }));
}

// Returns up to `limit` cities from states that are land-adjacent to
// the given (stateSlug, citySlug). Operates entirely on CITIES_INDEX —
// no per-state module fetch — because the cards only render fields the
// index already carries (cityName, hardness, populationK, firstZip).
//
// Selection biases toward the largest cities in each neighbor state
// (population proxy) and round-robins across neighbors so no single
// neighbor dominates. Stable, deterministic order.
//
// stateAdjacencyMap is passed in from stateAdjacency.js so this module
// stays free of an adjacency-table dependency at the data-layer level.
// (Inverting that dependency would create a circular import.)
export function getNearbyCitySummariesAcrossStates(
  stateSlug,
  citySlug,
  stateAdjacencyMap,
  limit = 6,
) {
  if (!stateSlug || !stateAdjacencyMap) return [];
  const neighbors = stateAdjacencyMap[stateSlug] || [];
  if (neighbors.length === 0) return [];
  // Bucket per neighbor, sorted by population desc.
  const buckets = {};
  for (const n of neighbors) {
    buckets[n] = CITIES_INDEX
      .filter((c) => c.stateSlug === n)
      .sort((a, b) => (b.populationK || 0) - (a.populationK || 0));
  }
  const out = [];
  let drewSomething = true;
  while (out.length < limit && drewSomething) {
    drewSomething = false;
    for (const n of neighbors) {
      if (out.length >= limit) break;
      const bucket = buckets[n];
      if (bucket && bucket.length > 0) {
        out.push(bucket.shift());
        drewSomething = true;
      }
    }
  }
  return out;
}

// Vite lazy glob — every per-state cities module under
// ./enriched/<stateSlug>.js, keyed by relative path. Each value is a
// function returning a promise resolving to the module. Rollup emits
// one chunk per state.
//
// Session 41 — the glob points to the enriched/ directory rather than
// ./<stateSlug>.js directly. Source-of-truth lives in
// src/data/cities/<stateSlug>.js (hand-edited); the enriched copies
// are generated by scripts/inject-city-sibling-links.mjs as a
// prebuild step and carry inline markdown links to sibling-city pages
// in the focused city's prose fields. CityPage interprets those
// links via its renderInlineLinks helper. This mirrors the v39 split
// between src/states/*.md (source) and src/states/enriched/*.md
// (build-time enriched output).
//
// We don't expose `cityModules` directly. Callers should use
// `loadCitiesByState(stateSlug)`, which abstracts the path-key lookup
// and unwraps the default export.
const cityModules = import.meta.glob('./enriched/*.js');

// Load the full city records for every city in the given state.
// Returns a promise resolving to an array of full city objects, or
// an empty array if no module exists for the slug.
export function loadCitiesByState(stateSlug) {
  if (!stateSlug) return Promise.resolve([]);
  // Guard the index.js path-key — a stateSlug of 'index' is not a valid
  // state and would otherwise return CITIES_INDEX wrapped as a
  // default-less module.
  if (stateSlug === 'index') return Promise.resolve([]);
  const key = `./enriched/${stateSlug}.js`;
  const loader = cityModules[key];
  if (!loader) return Promise.resolve([]);
  return loader().then((mod) => (Array.isArray(mod.default) ? mod.default : []));
}

// Load the full record for a single focused city. Loads the parent
// state's per-state module (which contains all cities in that state)
// and returns the matching entry, or null if not found.
export function loadCityBySlug(stateSlug, citySlug) {
  return loadCitiesByState(stateSlug).then((cities) => {
    if (!Array.isArray(cities)) return null;
    return cities.find((c) => c.citySlug === citySlug) || null;
  });
}
